import React from "react";
import './TabbedSection.css';

class TabbedSection extends React.Component {
  constructor(props) {
    super(props);
    const savedIndex = localStorage.getItem(`tabbed-section-${props.id}`);
    this.state = {
      selectedIndex: savedIndex ? parseInt(savedIndex, 10) : 0
    };
  }

  handleTabClick = (index) => {
    this.setState({ selectedIndex: index });
    localStorage.setItem(`tabbed-section-${this.props.id}`, index);
  };

  renderTabs() {
    return this.props.tabs.map((tab, index) => (
      <button
        key={index}
        className={`tab-label ${this.state.selectedIndex === index ? 'active' : ''}`}
        onClick={() => this.handleTabClick(index)}
      >
        {tab.content}
      </button>
    ));
  }

  renderTabContent() {
    return (
      <div className="tab-content">
        {this.props.children[this.state.selectedIndex]}
      </div>
    );
  }

  render() {
    return (
      <div className="tabbed-section">
        <div className="tab-container">
          <div className="tab-labels">
            {this.renderTabs()}
          </div>
          {this.renderTabContent()}
        </div>
      </div>
    );
  }
}

export default TabbedSection;